import { ReferenceField } from 'react-admin';
import { ActivityLog, MissionNote } from '@wwf/sdk';
import { ActivityLogNote } from './ActivityLogNote';
import { ActivityLogContextValue } from './types';
import { MissionLightCard } from '@app/mission/show/MissionLightCard';
import { MissionIcon } from '@app/mission/MissionIcon';
import { getLinkToMission } from '@app/mission/getLinkToMission';

type ActivityLogMissionNoteCreatedProps = {
    activity: ActivityLog;
    context: ActivityLogContextValue;
};

export function ActivityLogMissionNoteCreated({
    activity,
    context,
}: ActivityLogMissionNoteCreatedProps) {
    const missionNote = activity.entityData as unknown as MissionNote;

    return (
        <ActivityLogNote
            activity={activity}
            context={context}
            header={
                <>
                    <MissionIcon />
                    <ReferenceField
                        source="missionId"
                        reference="mission"
                        record={missionNote}
                        link={false}
                    >
                        <MissionLightCard noDate />
                    </ReferenceField>
                </>
            }
            text={missionNote.text ?? 'No text'}
            link={getLinkToMission(missionNote.missionId, 'show_notes')}
        />
    );
}
